var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { makeObservable, observable, action } from "mobx";
export class AddEventStore {
    constructor() {
        this.left = 100;
        this.top = 100;
        this.width = 500;
        this.height = 500;
        this.show = false;
        this.eventname = "";
        this.startdate = -1;
        this.enddate = -1;
        //   @observable public links: CalendarLink[] = [];
        this.location = "";
        //  @observable public notifications: CalendarNotification[] = [];
        this.dragging = false;
        makeObservable(this);
    }
    setEventName(name) {
        this.eventname = name;
    }
    setLocation(loc) {
        this.location = loc;
    }
    setShow(show) {
        this.show = show;
    }
    setDragging(dragging) {
        this.dragging = dragging;
    }
    setLeft(left) {
        this.left = left;
    }
    setTop(top) {
        this.top = top;
    }
    setStartDate(date) {
        this.startdate = date;
    }
    setEndDate(date) {
        this.enddate = date;
    }
    reset() {
        this.setShow(false);
        this.setDragging(false);
        //  this.notifications.splice(0, this.notifications.length);
        //   this.links.splice(0, this.links.length);
        this.setEventName("");
        this.setStartDate(-1);
        this.setEndDate(-1);
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], AddEventStore.prototype, "left", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AddEventStore.prototype, "top", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AddEventStore.prototype, "width", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AddEventStore.prototype, "height", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AddEventStore.prototype, "show", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AddEventStore.prototype, "eventname", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AddEventStore.prototype, "startdate", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AddEventStore.prototype, "enddate", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], AddEventStore.prototype, "location", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AddEventStore.prototype, "dragging", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AddEventStore.prototype, "setEventName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AddEventStore.prototype, "setLocation", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AddEventStore.prototype, "setShow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AddEventStore.prototype, "setDragging", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AddEventStore.prototype, "setLeft", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AddEventStore.prototype, "setTop", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AddEventStore.prototype, "setStartDate", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AddEventStore.prototype, "setEndDate", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AddEventStore.prototype, "reset", null);
